import { useEffect, useState } from 'react';
export const useKnowMoreDetails = (
  defaultValue: any,
  isMobileDevice: boolean
) => {
  const [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ] = useState(defaultValue);
  useEffect(() => {
    if (isMobileDevice)
      if (selectedKnowMoreDetailsForMobile) {
        const bodyElement = document.querySelector('body');
        selectedKnowMoreDetailsForMobile &&
          bodyElement &&
          bodyElement.classList.add('fixed');
      } else {
        const bodyElement = document.querySelector('body');
        !selectedKnowMoreDetailsForMobile &&
          bodyElement &&
          bodyElement.classList.remove('fixed');
      }
  }, [selectedKnowMoreDetailsForMobile]);
  return [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ];
};
